<template>
  <loading v-if="loading" />
  <b-alert
    show
    variant="danger"
    class="text-center"
    v-else-if="!loading && errorMessagesGetList.length > 0"
  >
    <p v-for="(err, i) in errorMessagesGetList" :key="i">
      <b-icon
        icon="exclamation-circle-fill"
        class="ml-2"
        font-scale="0.5"
        variant="warning"
      ></b-icon>
      {{ err }}
    </p>
  </b-alert>
  <empty-list
    v-else-if="
      !loading && errorMessagesGetList.length === 0 && items.length === 0
    "
    :srcImage="require('@/assets/images/payment-empty.png')"
    btnText="افزایش اعتبار"
    @btnCreateClicked="changeToAddPaymentRoute"
  >
    <template v-slot:messages>
      <p>
        <strong>با افزایش اعتبار می‌توانید از خدمات ما استفاده نمایید.</strong>
      </p>
    </template>
  </empty-list>
  <main-page-service
    v-else
    title="پرداخت‌ها"
    btnText="افزایش اعتبار"
    @btnCreateClicked="changeToAddPaymentRoute"
  >
    <b-table
      responsive
      hover
      :items="items"
      :fields="fields"
      table-class="table-list-table"
      thead-tr-class="table-list-thead-tr"
      tbody-tr-class="table-list-tbody-tr"
    >
      <template #cell(amount)="data">
        {{ data.item.amount }}<span style="font-size: 10px">ریال</span>
      </template>
      <template #cell(status)="data">
        <h5 v-if="data.item.status === 1">
          <b-badge variant="danger">
            ناموفق
          </b-badge>
        </h5>
        <h5 v-else-if="data.item.status === 2">
          <b-badge variant="success">
            موفق
          </b-badge>
        </h5>
      </template>
    </b-table>
  </main-page-service>
</template>

<script>
import EmptyList from "@/components/EmptyList/EmptyList.vue";
import Loading from "@/components/Loading/Loading.vue";
import MainPageService from "@/components/MainPageService/MainPageService.vue";
import { paymentListAdmin } from "@/services/payment";
import { numberSpliter } from "@/utils/functions";

export default {
  components: { Loading, EmptyList, MainPageService },
  data() {
    return {
      loading: false,
      fields: [
        {
          key: "userName",
          label: "نام کاربری",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "trackingNumber",
          label: "کد پیگیری",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "amount",
          label: "مبلغ",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "gateway",
          label: "درگاه",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "createdAt",
          label: "تاریخ",
          thClass: "text-center",
          tdClass: "text-center dir-ltr",
          sortable: true
        },
        {
          key: "status",
          label: "وضعیت",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        }
      ],
      items: [],
      errorMessagesGetList: []
    };
  },
  mounted() {
    this.getPaymentListAdmin();
  },
  methods: {
    editAmountData: function(val) {
      numberSpliter(val);
    },
    changeToAddPaymentRoute: function() {
      this.$router.push("/payment/add");
    },
    getPaymentListAdmin: async function() {
      this.loading = true;
      const [error, data] = await paymentListAdmin();
      if (error) {
        this.loading = false;
        this.errorMessagesGetList = error;
      } else {
        if (data.apiStatus === 200) {
          data.apiData.map(item => {
            item["amount"] = numberSpliter(item["amount"]);
          });
          this.items = [...data.apiData];
          this.loading = false;
        } else {
          this.loading = false;
          this.errorMessagesGetList = data.apiErrors;
        }
      }
    }
  }
};
</script>

<style scoped>
.dir-ltr {
  direction: ltr;
}
</style>
